(ns common.schema.entities.counterparty-diligence.util
  (:require
   [common.roles :as roles]
   [common.schema.entities.counterparty-diligence.templates.registry :as template-registry]
   [common.util :as cu]
   [clojure.string :as string]))

;; Verbatim copy of common.schema.entity-types's shared admin-delete-check-fn
;; (entity_types.cljc, ~line 331) - reproduced here, not required from there,
;; to avoid a circular dependency (entity_types.cljc requires the new
;; entity-type-registry, which requires the three counterparty-diligence
;; core.cljc namespaces that need this check). Shared across all three
;; (company/person/project) since the original :entity/disable-permissions-check-fn
;; is the same admin-only check for all of them.
(defn admin-delete-check-fn
  [{:keys [tr role] :as _ctx}]
  (when-not (roles/admin? role)
    (tr :only-admin-can-delete-this-entity)))

(defn template-option-filter
  [{:keys [search-str-lc
           tenant
           _containing-entity
           entity-candidate
           _entity-types-lookup]
    :as   _filter-args}]
  (let [capman? (= (:tenant/name tenant) "CapMan")
        template-id (:value entity-candidate)
        access? (cond
                  capman? (template-registry/capman-template? template-id)
                  :else (template-registry/demo-template? template-id))

        search-match? (or (cu/blank-value? search-str-lc)
                          (string/starts-with? (:label-lc entity-candidate) search-str-lc))]
    (and access? search-match?)))
